/* 觸發下載。集中在這裡的理由：錨點必須放進 DOM 才會下載（Firefox 尤其如此），
   而這個細節很容易在某一份實作裡漏掉。 */
export function downloadBytes(bytes: Uint8Array, fileName: string, mime = "application/octet-stream"): void {
  const blob = new Blob([bytes as unknown as BlobPart], { type: mime });
  downloadBlob(blob, fileName);
}

export function downloadBlob(blob: Blob, fileName: string): void {
  const anchor = document.createElement("a");
  anchor.href = URL.createObjectURL(blob);
  anchor.download = fileName;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  setTimeout(() => { URL.revokeObjectURL(anchor.href); anchor.remove(); }, 4000);
}
